module.exports = __webpack_public_path__ + "static/04-2d9eb35f24770a486dc6006101873bae.jpg";